// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__W0va6"};